import { IBaseAction } from '@models/actions/IBaseAction';
import { ModalSize } from '@srm/ui/types/ModalSize';
import { ActivityBaseActionExecutor } from './ActivityBaseActionExecutor';
import { buildModalExecutorContext, IModalExecutorOptions } from './createModalExecutor';

/**
 * Экзекьютор действия активити, вся работа которого — собрать пропсы и показать модалку;
 * проверки accessibility остаются за {@link ActivityBaseActionExecutor}.
 */
export const createActivityModalExecutor = <TProps extends object>(options: IModalExecutorOptions<TProps>) => {
    const Modal = options.modal;
    const empty = options.emptyElement ?? <></>;

    return class extends ActivityBaseActionExecutor {
        private _modalProps?: TProps;

        runInternal = (
            objId: string,
            parentId: string | undefined,
            action: IBaseAction,
            rowData?: any,
            completeHandler?: (isSucceed: boolean) => void,
            modalSize?: ModalSize | null,
        ) => {
            this._modalProps = options.mapProps(
                buildModalExecutorContext(options, objId, parentId, action, rowData, completeHandler, modalSize),
            );
        };

        visualElementInner = () => (this._modalProps ? <Modal {...this._modalProps} /> : empty);
    };
};
